import React from "react";
import {
  AiFillFacebook,
  AiFillMail,
  AiFillTwitterCircle,
  AiFillYoutube,
} from "react-icons/ai";
import { NavLink } from "react-router-dom";

import ScrollToTopButton from "../utilities/ScrollToTopButton";

function Footer() {
  return (
    <div className="bg-blue-100 pt-10 font-primary">
      {/* newsletter */}
      <div className="w-[88%] rounded-xl mx-auto h-20 bg-white flex justify-around items-center">
        <h3 className="text-primary font-bold md:text-2xl text-sm md:w-auto w-10">
          Subscribe newsletter
        </h3>
        <div className="flex ml-4 justify-center items-center text-white">
          <input
            type="text"
            placeholder="Email Address"
            className="placeholder-white md:w-auto w-40 rounded-l-lg p-4 text-white bg-yellow-500 outline-none border-none"
          />
          <button className="p-4 rounded-r-lg bg-yellow-500">
            <AiFillMail color="white" size="24" />
          </button>
        </div>
      </div>
      {/* footer links */}
      <div className="font-primary text-primary pt-10 md:pb-10 flex md:flex-row flex-col md:justify-around justify-center items-center">
        <div className="md:pb-10 text-left w-40 flex flex-col justify-start h-52">
          <h1 className="font-bold text-2xl pb-3">DigitalMechanic</h1>
          <div className="divide-y divide-slate-300">
            <p className="pb-4">62/3, PAF Base Kohat</p>
            <div className="pt-4 flex justify-between">
              <AiFillFacebook size="25" color="blue" />
              <AiFillTwitterCircle size="25" color="blue" />
              <AiFillYoutube size="25" color="red" />
            </div>
          </div>
        </div>
        <div className="md:pb-0 pb-10 text-left w-40">
          <h2 className="text-xl font-bold md:mt-6">Find Tools</h2>
          <ul className="flex flex-col justify-between h-52 py-2">
            <li>
              <NavLink to="/shop">Tires</NavLink>
            </li>
            <li>
              <NavLink to="/shop">Helmets</NavLink>
            </li>
            <li>
              <NavLink to="/shop">Batteries</NavLink>
            </li>
            <li>
              <NavLink to="/shop">Generators</NavLink>
            </li>
            <li>
              <NavLink to="/shop">Engines</NavLink>
            </li>
          </ul>
        </div>
        <div className="md:pb-0 pb-10 text-left w-40">
          <h2 className="text-xl font-bold md:mt-6">Mechanic Services</h2>
          <ul className="flex flex-col justify-between h-52 py-4">
            <li>
              <NavLink to="/services">Car Mechanic</NavLink>
            </li>
            <li>
              <NavLink to="/services">Bike Mechanic</NavLink>
            </li>
            <li>
              <NavLink to="/services">Generators</NavLink>
            </li>
            <li>
              <NavLink to="/services">Refrigerator</NavLink>
            </li>
          </ul>
        </div>
        <div className="md:pb-0 pb-10 text-left w-40">
          <h2 className="text-xl font-bold md:mt-6">Navigation</h2>
          <ul className="flex flex-col justify-between h-52 py-4">
            <li>Home</li>
            <li>Blog</li>
            <li>Shop</li>
            <li>Services</li>
            <li>Bookings</li>
          </ul>
        </div>
      </div>
      <div className="bg-primary text-gray-300 py-4">
        <div className="container mx-auto">
          <p className="text-center">Copyright © 2023</p>
        </div>
        <ScrollToTopButton />
      </div>
    </div>
  );
}

export default Footer;
